import { useGetAppointmentDuration } from "~/screens/Scheduling/InitialVisit/hooks/use-get-appointment-duration";
import { visitTypeLabels, type VisitType } from "~/services";

const VisitTypeSubtitle = ({ visitType }: { visitType: VisitType }) => {
  const { duration } = useGetAppointmentDuration(visitType);
  const label = visitTypeLabels[visitType];

  return (
    <p className="text-violet80 text-base font-medium">
      {duration ? `${label} (${duration} min)` : label}
    </p>
  );
};

export const StepHeading = ({
  title,
  visitType,
}: {
  title: string;
  visitType?: VisitType | null;
}) => (
  <div className="border-light-lavender-gray flex flex-col gap-2 border-b pb-4">
    <h2
      tabIndex={-1}
      className="font-ivy text-indigo text-2xl font-normal leading-8 tracking-tight focus:outline-none"
    >
      {title}
    </h2>
    {visitType && <VisitTypeSubtitle visitType={visitType} />}
  </div>
);
